import { render } from "./index.vue?vue&type=template&id=3f3b6f62&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=3f3b6f62&scoped=true&lang=css"

import exportComponent from "E:\\项目对接\\parent-reporting-backend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3b6f62"]])

export default __exports__